import { createMagicDoorContext } from '~/contexts/utils';
import { SignalRService } from '~/utils/signalRService';

export const [SignalRProvider, useSignalR] = createMagicDoorContext<SignalRService>('SignalR', () => {
  return new SignalRService('/ws/chat');
});
